import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';
import edenredLogo from 'src/assets/img/edenredlogo.png';
import companyStamp from 'src/assets/img/companyStamp.JPG';

const generateTransactionStatementPDF = (formattedData) => {
    const doc = new jsPDF();

    doc.setFont('helvetica');
    doc.addImage(edenredLogo, 'PNG', 10, 10, 35, 20);
    doc.setTextColor(0, 0, 0);

    const tableData = [];

    // Add transaction rows
    formattedData.forEach((transaction) => {
        tableData.push([
            transaction.date,
            transaction.branchId,
            transaction.description || 'N/A',
            transaction.type,
            transaction.debit,
            transaction.credit
        ]);
    });

    // Create table using jspdf-autotable
    autoTable(doc, {
        head: [['Date', 'Branch Id', 'Description', 'Type', 'Debit (AED)', 'Credit (AED)']],
        body: tableData,
        startY: 40,
        margin: { left: 10, right: 10 },
        styles: {
            fontSize: 8,
            cellPadding: 2,
        },
        headStyles: {
            fillColor: [237, 28, 36], // Red background
            textColor: [255, 255, 255], // White text
            fontStyle: 'bold',
            cellPadding: 1,
        },
        columnStyles: {
            0: { cellWidth: 20 }, // Date
            1: { cellWidth: 35 }, // Branch Id
            2: { cellWidth: 65 }, // Description
            3: { cellWidth: 15 }, // Type
            4: { cellWidth: 25, halign: 'right' }, // Debit (AED) - right aligned
            5: { cellWidth: 25, halign: 'right' }, // Credit (AED) - right aligned
        },
        alternateRowStyles: {
            fillColor: [245, 245, 245], // Light gray for alternate rows
        },
        didDrawPage: function (data) {
            doc.setFontSize(8);
            doc.text('Page ' + doc.internal.getNumberOfPages(), 10, doc.internal.pageSize.height - 10);
        }
    });


    const stampWidth = 40;
    const stampHeight = 30;
    const margin = 10;

    // Calculate table end position based on actual rendered height
    const tableEndY = (doc.lastAutoTable && doc.lastAutoTable.finalY) ? doc.lastAutoTable.finalY : 40;

    // Position stamp below the table, right-aligned
    const stampX = doc.internal.pageSize.width - stampWidth - margin;
    let stampY = tableEndY + margin;

    // If the stamp would overflow the page, add a new page
    if (stampY + stampHeight + margin > doc.internal.pageSize.height) {
        doc.addPage();
        stampY = margin;
    }

    doc.addImage(companyStamp, 'JPEG', stampX, stampY, stampWidth, stampHeight);

    return doc;
};

export default generateTransactionStatementPDF; 